import {
    useComputedCurationConfigValue,
    useCurationConfigValue
} from '../../../hooks/widgetConfiguration.js';

import useListeningSearchTimePeriodDuration from './useListeningSearchTimePeriodDuration.js';
import useGetFilterSelectedIds from './useGetFilterSelectedIds.js';


function parsedFilterValue(value) {
    if (!value) {
        return null;
    }

    if (_.isString(value)) {
        return value.split(',');
    }

    return value;
}

const hasOverride = (overrides, override) => {
    return ((overrides || []).indexOf(override) >= 0);
};

export default function useListeningCurationFilterValues(instanceId, overrides) {

    // NOTE used to determine if we should clobber the start and end dates with
    // our special date picking apparatus
    const hasValueOverride = _.partial(hasOverride, overrides);

    const {currentlySelectedIds: selectedSourceIds} = useGetFilterSelectedIds(instanceId, 'source');
    const {currentlySelectedIds: selectedLanguage} = useGetFilterSelectedIds(instanceId, 'language');

    const listening = {
        searchTerms: parsedFilterValue(useCurationConfigValue(instanceId, 'searchTerms')),
        source: selectedSourceIds,
        geo: parsedFilterValue(useCurationConfigValue(instanceId, 'geo')),
        sentiment: parsedFilterValue(useCurationConfigValue(instanceId, 'sentiment')),
        language: (_.isArray(selectedLanguage) ? selectedLanguage[0] : selectedLanguage),
        searchTermsAnd: parsedFilterValue(useCurationConfigValue(instanceId, 'searchTermsAnd')),
        searchTermsNot: parsedFilterValue(useCurationConfigValue(instanceId, 'searchTermsNot')),
        phrase: useCurationConfigValue(instanceId, 'phrase'),
        domain: useCurationConfigValue(instanceId, 'domain'),
        excludeDomain: useCurationConfigValue(instanceId, 'excludeDomain'),
        hashtag: useCurationConfigValue(instanceId, 'hashtag'),
        person: useCurationConfigValue(instanceId, 'person'),
        brand: useCurationConfigValue(instanceId, 'brand'),
        gender: useCurationConfigValue(instanceId, 'gender'),
        like: useCurationConfigValue(instanceId, 'like'),
        dislike: useCurationConfigValue(instanceId, 'dislike'),
        positiveEmotion: useCurationConfigValue(instanceId, 'positiveEmotion'),
        negativeEmotion: useCurationConfigValue(instanceId, 'negativeEmotion'),
        positiveBehavior: useCurationConfigValue(instanceId, 'positiveBehavior'),
        negativeBehavior: useCurationConfigValue(instanceId, 'negativeBehavior'),
        author: useCurationConfigValue(instanceId, 'author'),
        excludeAuthor: useCurationConfigValue(instanceId, 'excludeAuthor'),
        theme: useCurationConfigValue(instanceId, 'theme')
    };

    const listeningQueryId = useCurationConfigValue(instanceId, 'listeningQueryId');
    const topicId = useCurationConfigValue(instanceId, 'topicId');

    if (listeningQueryId) {
        listening.listeningQueryId = listeningQueryId;
    } else if (topicId) {
        listening.topicId = topicId;
    }

    const timePeriodDuration = useListeningSearchTimePeriodDuration(instanceId);
    const timezone = useCurationConfigValue(instanceId, 'timezone');

    let startDate = useCurationConfigValue(instanceId, 'startDate') || moment.tz(timezone).subtract(timePeriodDuration, 'day').startOf('day').toISOString();
    let endDate = useCurationConfigValue(instanceId, 'endDate') || moment.tz(timezone).endOf('day').toISOString();

    const plan = useCurationConfigValue(instanceId, 'plan');
    const dateRanges = useComputedCurationConfigValue(instanceId, 'dateRanges');
    if (!hasValueOverride('startDate') && !hasValueOverride('endDate')) {
        if (plan?.has_full_instant_search) {
            startDate = dateRanges.main.start;
            endDate = dateRanges.main.end;
        }
    }

    const timePeriod = {
        startDate: startDate,
        endDate: endDate,
        timezone: timezone
    };

    return {
        listening,
        timePeriod
    };
}
